import DevicePairing from 'Components/device-pairing';

export default {
	name: 'SetupFirstDevice',
	components: {
		DevicePairing
	},
	created() {},
	data() {
		return {};
	},
	methods: {}
};



// WEBPACK FOOTER //
// ./app/components/devices/setup-first-device/script.js